import React, {useEffect, useState} from 'react';
import {createMqttClient, MqttMessage, MqttStatus, subscribeTopic, useMQTTPublish} from "./components/Mqtt/mqtt";
import MqttConnectionBadge from "./components/Badge/MqttConnectionBadge";
import mqtt from "mqtt/*";
import {
    mqttCmd,
    mqttExtCmd,
    mqttExtJetztSchluss,
    mqttExtSicherungen,
    mqttExtSprache,
    mqttExtStatus,
    mqttExtStep,
    mqttInputMode,
    mqttJetztSchluss,
    mqttNumpad,
    mqttSicherungen,
    mqttSprache,
    mqttStep,
    mqttVentil,
    mqttVentilDiff
} from "./components/Mqtt/Topic";
import SicherungenScreen, {Windowsfenster} from "./components/Ausgabe/SicherungenScreen";
import Aufgabe from "./components/Ausgabe/Aufgabe";

const subscriptions: subscribeTopic[] = [
    {
        topic: mqttSicherungen.name,
        qos: 2,
    },
    {
        topic: mqttNumpad.name,
        qos: 2,
    },
    {
        topic: mqttVentil.name,
        qos: 2,
    },
    {
        topic: mqttSprache.name,
        qos: 2,
    },
    {
        topic: mqttExtJetztSchluss.name,
        qos: 2,
    },
    {
        topic: mqttJetztSchluss.name,
        qos: 2,
    },
    {
        topic: mqttStep.name,
        qos: 2,
    },
    {
        topic: mqttCmd.name,
        qos: 2,
    },
];

export type Step = {
    schritt: number;
    fortschritt: number;
    type: string;
}

const DefaultStep: Step = {
    schritt: 1,
    fortschritt: 1,
    type: 'symbol',
}

enum langKey {
    ladebalkenTitle,
    ladebalkenMeldung,
    tuerOffnenMessage,
    tuerOffnenTitle,
}

export default function App() {
    const [client, setClient] = useState<mqtt.MqttClient | null>(null);
    const [mqttStatus, setMqttStatus] = useState<MqttStatus>('Undefined');
    const [sicherungen, setSicherungen] = useState(0b00000);
    const [numpad, setNumpad] = useState('');
    const [ventil, setVentil] = useState(270);
    const [style, setStyle] = useState({
        transform: "rotate(100deg)",
        transition: "transform 50ms ease",
    })
    const [ladebalken, setLadebalken] = useState(0);
    const [step, setStep] = useState<Step>(DefaultStep)
    const [language, setLanguage] = useState('de');
    const [fehler, setFehler] = useState('');
    const [jetztSchluss, setJetztSchluss] = useState(false);
    const [sicherungenDone, setSicherungenDone] = useState(false);
    const [allDone, setAllDone] = useState(false)

    const publishMqtt = useMQTTPublish(client);

    useEffect(() => {
        if (ladebalken > 0) {
            if (ladebalken >= 1) {
                aufgabeErledigt();

                if (step.schritt === 100) {
                    return;
                }

                setLadebalken(0);
            }
            const timeoutId = setTimeout(() => setLadebalken(ladebalken + 0.20), 200);

            return () => clearTimeout(timeoutId);
        }
    }, [ladebalken]);

    useEffect(() => {
        if (step.type === 'skala' || step.type === 'anzeige' || step.type === 'final') {
            publishMqtt(mqttInputMode.name, 'mehrstellig', 2, true);
        } else {
            publishMqtt(mqttInputMode.name, 'einzeln', 2, true);
        }
    }, [step]);

    function checkSchluss() {
        if (jetztSchluss && step.schritt !== 100) {
            setStep({schritt: 100, fortschritt: 0, type: 'final'})
            setNumpad('')
            setFehler('')
            return true;
        }
    }

    function aufgabeErledigt() {
        if (step.schritt === 1 && step.fortschritt === 1 && step.type === "symbol") {
            if (numpad === '5') {
                setNumpad('')
                setFehler('')
                if (checkSchluss()) {
                    return
                }
                setStep({schritt: 1, fortschritt: 2, type: 'wert'})
                return;
            } else {
                setFehler(numpad);
                return;
            }
        } else if (step.schritt === 1 && step.fortschritt === 2 && step.type === "wert") {
            if (3 <= ventil && ventil <= 12) {
                setNumpad('');
                setFehler('');
                if (checkSchluss()) {
                    return
                }
                setStep({schritt: 2, fortschritt: 1, type: 'anzeige'})
                return;
            } else {
                setFehler(ventil.toString());
                return;
            }
        } else if (step.schritt === 2 && step.fortschritt === 1 && step.type === "anzeige") {
            if (numpad === '008341') {
                setNumpad('');
                setFehler('');
                if (checkSchluss()) {
                    return
                }
                setStep({schritt: 2, fortschritt: 2, type: 'wert'})
                return;
            } else {
                setFehler(numpad);
                setNumpad('');
                return;
            }
        } else if (step.schritt === 2 && step.fortschritt === 2 && step.type === "wert") {
            if (268 <= ventil && ventil <= 272) {
                setNumpad('');
                setFehler('');
                if (checkSchluss()) {
                    return
                }
                setStep({schritt: 3, fortschritt: 1, type: 'anzeige'})
                return;
            } else {
                setFehler(ventil.toString());
                return;
            }
        } else if (step.schritt === 3 && step.fortschritt === 1 && step.type === "anzeige") {
            if (numpad === '63571') {
                setNumpad('');
                setFehler('');
                if (checkSchluss()) {
                    return
                }
                setStep({schritt: 3, fortschritt: 2, type: 'skala'})
                return;
            } else {
                setFehler(numpad);
                setNumpad('');
                return;
            }
        } else if (step.schritt === 3 && step.fortschritt === 2 && step.type === "skala") {
            if (numpad === '42') {
                setNumpad('');
                setFehler('');
                if (checkSchluss()) {
                    return
                }
                setStep({schritt: 4, fortschritt: 1, type: 'skala'})
                return;
            } else {
                setFehler(ventil.toString());
                return;
            }
        } else if (step.schritt === 4 && step.fortschritt === 1 && step.type === "skala") {
            if (numpad === '185') {
                setJetztSchluss(true);
                setNumpad('');
                setFehler('');
                if (checkSchluss()) {
                    return
                }
                setStep({schritt: 100, fortschritt: 0, type: 'final'})
            } else {
                setFehler(numpad);
                return;
            }
        } else if (step.schritt === 100 && step.fortschritt === 0 && step.type === "final") {
            if (numpad === '18042') {
                setNumpad('')
                setFehler('')
                setLadebalken(0.01);
                setAllDone(true);
                publishMqtt(mqttCmd.name, 'all-done', 2, false);
            } else {
                setFehler(numpad);
                return;
            }
        }
    }


    function onMessage(mqttMessage: MqttMessage) {
        if (mqttMessage.topic === mqttSicherungen.name) {
            setSicherungen((parseInt(mqttMessage.message) >>> 0))

            if (jetztSchluss && parseInt(mqttMessage.message) === 0b11111) {
                setStep({schritt: 100, fortschritt: 0, type: 'final'})
            }
            //
            // if (!sicherungenUncomplete && parseInt(mqttMessage.message) !== 0b11111) {
            //     setSicherungenUncomplete(true);
            // }
        } else if (mqttMessage.topic === mqttNumpad.name) {
            if (mqttMessage.message === '*') {
                setNumpad('');
                return
            } else if (mqttMessage.message === '#') {
                // setShowVentil(!showVentil);
                if (step.schritt === 100) {
                    return
                }
                setLadebalken(0.01)
                return
            }

            setNumpad(mqttMessage.message);
        } else if (mqttMessage.topic === mqttVentil.name) {
            setVentil(mqttMessage.message);
        } else if (mqttMessage.topic === mqttVentilDiff.name) {

            // setVentil(mqttMessage.message + ventil);
        } else if (mqttMessage.topic === mqttSprache.name) {
            setLanguage(mqttMessage.message);
        } else if (mqttMessage.topic === mqttStep.name) {
            let values = mqttMessage.message.split(':');
            const schritt = parseInt(values[0]);
            const fortschritt = parseInt(values[1]);
            let wert = ''

            if (schritt === 1 && fortschritt === 1) {
                wert = 'symbol';
            } else if (schritt === 1 && fortschritt === 2) {
                wert = 'wert';
            } else if (schritt === 2 && fortschritt === 1) {
                wert = 'anzeige';
            } else if (schritt === 2 && fortschritt === 2) {
                wert = 'skala';
            } else if (schritt === 3 && fortschritt === 1) {
                wert = 'anzeige';
            } else if (schritt === 3 && fortschritt === 2) {
                wert = 'skala';
            } else if (schritt === 4 && fortschritt === 1) {
                wert = 'skala';
            } else if (schritt === 100 && fortschritt === 0) {
                wert = 'final';
                setJetztSchluss(true)
                setLadebalken(0)
            }
            setFehler('')
            setStep({schritt: schritt, fortschritt: fortschritt, type: wert});
        } else if (mqttMessage.topic === mqttJetztSchluss.name) {
            if (mqttMessage.message === 'ja') {
                setJetztSchluss(true);
            } else {
                setJetztSchluss(false);
            }
        } else if (mqttMessage.topic === mqttCmd.name) {
            if (mqttMessage.message === 'reset') {
                setFehler('');
                setNumpad('');
                setJetztSchluss(false);
                setLadebalken(0);
                setLanguage('de');
                setSicherungenDone(false);
                setAllDone(false);
                setStep({schritt: 1, fortschritt: 1, type: 'symbol'});
            }
        }
    }

    useEffect(() => {
        setClient(createMqttClient(
            'ausgabe-' + Math.random().toString(16).substring(2, 10),
            String(process.env.REACT_APP_MQTT_USERNAME),
            String(process.env.REACT_APP_MQTT_PASSWORD),
            String(process.env.REACT_APP_MQTT_HOST),
            Number(process.env.REACT_APP_MQTT_PORT),
            (process.env.REACT_APP_MQTT_LWT === 'true'),
            setMqttStatus,
            onMessage
        ))
    }, []);

    useEffect(() => {
        let newValue = 261;
        if (ventil <= 260 && ventil >= 180) {
            newValue = 260;
        } else if (ventil > 100 && ventil < 180) {
            newValue = 100;
        } else {
            newValue = ventil;
        }

        setStyle({
            transform: "rotate(" + newValue + "deg)",
            transition: "transform 0 ease",
        })
    }, [ventil]);

    useEffect(() => {
        if (mqttStatus === 'Connected') {
            if (process.env.REACT_APP_MQTT_LWT === 'true') {
                // console.log('LWT enabled');
                if (client && client.connected && client.options.will !== undefined && client.options.will !== null) {
                    client.publish(client.options.will.topic, 'online', {qos: 2, retain: true});
                }
            }

            // console.log('Subscribe MQTT topics');
            // console.log(subscriptions);

            for (let i = 0; i < subscriptions.length; i++) {
                client?.subscribe(subscriptions[i].topic, {qos: subscriptions[i].qos});
            }
        } else if (mqttStatus === 'Disconnected') {
            console.log('MQTT Disconnected');
            client?.reconnect();
        }
    }, [client, mqttStatus]);

    return <>
        {ladebalken > 0 && step.schritt !== 100 &&
            <EingabeWirdVerarbeitet ladebalken={ladebalken} language={language}/>}
        {ladebalken > 0 && allDone && step.schritt === 100 && step.fortschritt === 0 && step.type === 'final' && <>
            <TuerWirdGeoeffnet ladebalken={ladebalken} language={language}/>
        </>}
        <div className={'bg-w98-green absolute w-[1920px] h-[1080px]'}>
            <MqttConnectionBadge className={'absolute ml-3 mt-3 opacity-10'} label={mqttStatus}/>
            {step.type === 'wert' && sicherungenDone && <>
                <div
                    className={'absolute px-20 pb-20 pt-10 w-full flex flex-col gap-6 items-center justify-center h-full'}>
                    <div className="absolute pin">
                        <div className="inner">
                            <div id={'ventil-meter'} className={'line'} style={style}>

                            </div>
                        </div>
                    </div>
                </div>
            </>}
            <div className={'w-full h-full px-20 pb-20 pt-10'}>
                {!sicherungenDone && <>
                    <SicherungenScreen sicherungen={sicherungen} doneFunction={setSicherungenDone}
                                       language={language}/>
                </>}
                {sicherungenDone && <>
                    <Aufgabe fehler={fehler} numpad={numpad} step={step} language={language}/>
                </>}
            </div>
        </div>
    </>
}

function EingabeWirdVerarbeitet({ladebalken, language}: { ladebalken: number, language: string }) {
    return <>
        <div
            className={'absolute top-0 left-0 bg-w98-gray/75 w-[1920px] h-[1080px] z-10 flex items-center justify-center'}>
            <div className={'w-full h-full'}>
                <Windowsfenster className={'!shadow-xl !shadow-w98-dark-gray'}
                                title={text(langKey.ladebalkenTitle, language)}>
                    <p className={'text-3xl'}>{text(langKey.ladebalkenMeldung, language)}...</p>
                    <progress className={'w-7/8 bg-w98-white h-4'} value={ladebalken}/>
                </Windowsfenster>
            </div>
        </div>
    </>
}

function TuerWirdGeoeffnet({ladebalken, language}: { ladebalken: number, language: string }) {
    return <>
        <div
            className={'absolute top-0 left-0 bg-w98-gray/75 w-[1920px] h-[1080px] z-10 flex items-center justify-center'}>
            <div className={'w-full h-full'}>
                <Windowsfenster className={'!shadow-xl !shadow-w98-dark-gray'}
                                title={text(langKey.tuerOffnenTitle, language)}
                >
                    <p className={'text-4xl font-bold'}>{text(langKey.tuerOffnenTitle, language)}</p>
                    <p className={'text-3xl'}>{text(langKey.tuerOffnenMessage, language)}...</p>
                    <progress className={'w-7/8 bg-w98-white h-4'} value={ladebalken}/>
                </Windowsfenster>
            </div>
        </div>
    </>
}

function text(key: langKey, language: string): string {
    if (key === langKey.ladebalkenMeldung) {
        if (language === 'en') {
            return 'Processing data';
        } else {
            return 'Daten werden verarbeitet';
        }
    }
    if (key === langKey.ladebalkenTitle) {
        if (language === 'en') {
            return 'Check';
        } else {
            return 'Prüfung';
        }
    }
    if (key === langKey.tuerOffnenTitle) {
        if (language === 'en') {
            return 'Welcome!';
        } else {
            return 'Willkommen!';
        }
    }
    if (key === langKey.tuerOffnenMessage) {
        if (language === 'en') {
            return 'The door is opening...';
        } else {
            return 'Die Tür wird geöffnet...';
        }
    }

    return '';
}
